import FileItem from "./FileItem.component";

export default FileItem;
